import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSetQueryParams } from 'shared/auth/hooks/useQueryString';
import { getProgramNameUrl } from '../../ReportBuilder/Components/Budget/utils';
import { ReportingType } from './api';

interface GoToReportArgs {
  reportId: number;
  programId: number | null | undefined;
  programName: string | undefined;
  reportingType: ReportingType;
  /**
   * 'in-place' updates the current page's query params (only works on the
   * programs-and-reports page which renders the snapshot). 'navigate' pushes
   * to the programs-and-reports route so the snapshot renders from anywhere.
   */
  lightMode?: 'in-place' | 'navigate';
}

export const useGoToReport = () => {
  const { push } = useHistory();
  const setQueryParams = useSetQueryParams();

  return useCallback(
    ({
      reportId,
      programId,
      programName,
      reportingType,
      lightMode = 'navigate',
    }: GoToReportArgs) => {
      if (reportingType === 'LIGHT' || reportingType === 'SUPER_LIGHT') {
        if (lightMode === 'in-place') {
          setQueryParams({
            reportId,
            programId: programId ?? null,
          });
          // this is needed, because just setting query parameters doesn't trigger a re-render
          window.location.reload();
          return;
        }
        push(
          `/npo/programs-and-reports?programId=${programId}&reportId=${reportId}`,
        );
        return;
      }

      push(`/npo/report-builder/${getProgramNameUrl(programName)}/${reportId}`);
    },
    [push, setQueryParams],
  );
};
